module.exports = __webpack_public_path__ + "img/star.fa1b8817.svg";